module.exports = __webpack_public_path__ + "static/media/13.4d020da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/13.png
// module id = 337
// module chunks = 0